import { Container, Row, Col } from 'reactstrap';
import { SecondaryButton } from '../common/Buttons';
import './style.css';

export default function GuaranteeSection() {
  return (
    <section className="guarantee-gradient py-5 text-white">
      <Container>
        <Row className="justify-content-center">
          <Col md="10" lg="8" className="text-center">
            <h2 className="h1 fw-bold mb-3">Love Your Website or Get Your Money Back</h2>
            <p className="lead mb-4">
              We're so confident you'll love your new website that we offer a full 30-day money-back guarantee. No questions asked.
            </p>
            <SecondaryButton
              href="#packages"
            >
              Start Your Website Today
            </SecondaryButton>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
